import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { withQuery } from '../../../hoc/withGraphql';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import { updatePaymentGatewayLogo } from '../../../actions/siteadmin/paymentGatewayLogo';
import { logouploadDir } from '../../../config';
import { photosShow } from '../../../helpers/photosShow';
import messages from '../../../locale/jsonMessages';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import s from './ConfigSettingsForm.css';

const gatewayLogoQuery = gql`
  query getPaymentGatewayLogo($title: String!, $name: String!) {
    getSiteSettingsLogo(title: $title, name: $name) {
      title
      name
      value
      status
      errorMessage
    }
  }
`;

class PaymentGatewayLogoUploader extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    defaultLogo: PropTypes.string.isRequired
  };

  state = { uploading: false };

  upload = async event => {
    const file = event.target.files?.[0];
    if (!file || this.state.uploading) return;
    const { title, name, logoData, updatePaymentGatewayLogo, demoRestriction } = this.props;
    if (await demoRestriction({})) return;

    this.setState({ uploading: true });
    try {
      if (!file.size) throw new Error('Le fichier du logo est vide.');
      const body = new FormData();
      body.append('file', file);
      const response = await fetch('/uploadLogo', { method: 'POST', body, credentials: 'include' });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.error || 'Logo upload failed.');
      const fileName = result?.file?.filename;
      if (!fileName) throw new Error('Logo upload failed.');
      const saved = await updatePaymentGatewayLogo(title, name, fileName, logoData?.getSiteSettingsLogo?.value);
      if (!saved) throw new Error('Logo update failed.');
      await logoData.refetch();
      showToaster({ messageId: 'updateConfigSettings', toasterType: 'success' });
    } catch (error) {
      showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: error.message });
    } finally {
      this.setState({ uploading: false });
      event.target.value = '';
    }
  };

  render() {
    const { defaultLogo, logoData, intl: { formatMessage } } = this.props;
    const customLogo = logoData?.getSiteSettingsLogo?.value;
    const logo = customLogo ? photosShow(logouploadDir) + customLogo : defaultLogo;

    return <div className={s.gatewayLogoSetting}>
      <img className={s.gatewayLogoPreview} src={logo} alt="" onError={event => {
        if (event.currentTarget.src !== defaultLogo) event.currentTarget.src = defaultLogo;
      }} />
      <label className={s.gatewayLogoUpload}>
        {this.state.uploading ? '...' : formatMessage(messages.clickHeretoUploadLogo)}
        <input type="file" accept="image/png,image/jpeg" onChange={this.upload} disabled={this.state.uploading} />
      </label>
    </div>;
  }
}

const mapDispatch = { updatePaymentGatewayLogo, demoRestriction };

export default compose(
  injectIntl,
  withStyles(s),
  connect(null, mapDispatch),
  withQuery(gatewayLogoQuery, {
    name: 'logoData',
    options: props => ({
      ssr: false,
      fetchPolicy: 'network-only',
      variables: { title: props.title, name: props.name }
    })
  })
)(PaymentGatewayLogoUploader);
